export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13597.a55dc292.jpg";